import { render } from "./Index-heatAlarmSetting.vue?vue&type=template&id=08483099&scoped=true"
import script from "./Index-heatAlarmSetting.vue?vue&type=script&lang=js"
export * from "./Index-heatAlarmSetting.vue?vue&type=script&lang=js"

import "./Index-heatAlarmSetting.vue?vue&type=style&index=0&id=08483099&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Yuting_Shiu\\Desktop\\mes-chunyu-modify\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08483099"]])

export default __exports__